import React from 'react';
import { Modal,ModalHeader } from 'reactstrap';
import { ModalButtonSave, ModalButtonUpdate } from '../../constant';
import { DeleteFormProcessWS } from './DeleteFormProcessWS';
import { DeleteFormElementWS } from './DeleteFormElementWS';
import { DeleteFormDilutions } from './DeleteFormDilutions';
import { FormProcessCreate } from './FormProcessCreate';
import { FormElementsCreate } from './FormElementsCreate';
import { FormDilutionCreate } from './FormDilutionCreate';


export const ModalCreateUWSProcess = (props) => {
    const{
        catwsprocess, id_exam, idwsconfig, order_element, name, comment_dilutions_colonies, is_lm, is_ec, datadeterminations, validaciones,
        method,handleInputChange, handleSearchWSS, loading, 
        toggle, modal, modalTitle,saveCreate, saveUpdate, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,
        handleUpdateValues,handleSelectValues,formValues,handleSelectValuesNew,
        //elementos
        catwselement, id_elements_config, dataDatacatwselementSearch,
        handleSearchWSSElements, handleUpdateElements, saveUpdateElements, handleDeleteElements,
        saveDeleteElements, validarFormElements, handleCreateElements, saveCreateElements,
        formValuesElements, handleInputChangeElements, handleUpdateValuesElements, handleSelectValuesElements, validacionesElements,
         //diluciones
         handleSearchWSSDilutions,handleUpdateDilutions,saveUpdateDilutions,handleDeleteDilutions,
         saveDeleteDilutions,validarFormDilutions,handleCreateDilutions,saveCreateDilutions,
         formValuesDilutions, handleInputChangeDilutions, handleUpdateValuesDilutions, handleSelectValuesDilutions,
         validacionesDilutions,
    }=props;
    //console.log(name,"name");

    return (
        <Modal isOpen={modal} toggle={toggle} backdrop='static' keyboard={false} centered={true}>
            <ModalHeader toggle={toggle} className='bg-primary'>
                {modalTitle}
            </ModalHeader>
            {
                method === "create"
                ?<FormProcessCreate
                    button = {ModalButtonSave}
                    {...{catwsprocess,id_exam,idwsconfig, order_element, name,comment_dilutions_colonies,is_lm, is_ec, datadeterminations, validaciones,
                        method,handleInputChange, handleSearchWSS, loading, 
                        toggle, modal, modalTitle,saveCreate, saveUpdate, saveDelete,
                        nextPage, previousPage, goToPage, totalPageCount, currentPage,
                        handleUpdateValues,handleSelectValues,formValues,methodAction: saveCreate,handleSelectValuesNew,
                        }}
                />
                :
                (method === "createElement")
                ?
                <FormElementsCreate
                    button={ModalButtonSave}
                    {...{ methodAction: saveCreateElements,catwselement, id_elements_config, dataDatacatwselementSearch,
                        handleSearchWSSElements, handleUpdateElements, saveUpdateElements, handleDeleteElements,
                        saveDeleteElements, validarFormElements, handleCreateElements,
                        nextPage, previousPage, goToPage, totalPageCount, currentPage,loading,
                        formValuesElements, handleInputChangeElements, handleUpdateValuesElements, handleSelectValuesElements,
                        catwsprocess,validacionesElements}}
                />:
                (method === "createDilution")
                ?
                <FormDilutionCreate
                    button={ModalButtonSave}
                    {...{ methodAction: saveCreateDilutions,handleSearchWSSDilutions,handleUpdateDilutions,saveUpdateDilutions,handleDeleteDilutions,
                        saveDeleteDilutions,validarFormDilutions,handleCreateDilutions,
                        formValuesDilutions, handleInputChangeDilutions, handleUpdateValuesDilutions, handleSelectValuesDilutions,
                        validacionesDilutions,loading,catwsprocess}}
                />:
                (method === "update")
                ?
                <FormProcessCreate
                    button={ModalButtonUpdate}
                    {...{ catwsprocess,id_exam,idwsconfig, order_element, name,comment_dilutions_colonies,is_lm, is_ec, datadeterminations, validaciones,
                        method,handleInputChange, handleSearchWSS, loading, 
                        toggle, modal, modalTitle,saveCreate, saveUpdate, saveDelete,
                        nextPage, previousPage, goToPage, totalPageCount, currentPage,
                        handleUpdateValues,handleSelectValues,formValues, methodAction: saveUpdate ,handleSelectValuesNew,
                      }}
                />
                : (method === "updateelements")
                ?
                <FormElementsCreate
                    button={ModalButtonUpdate}
                    {...{
                        methodAction: saveUpdateElements,catwselement, id_elements_config, dataDatacatwselementSearch,
                        handleSearchWSSElements, handleUpdateElements, saveUpdateElements, handleDeleteElements,
                        saveDeleteElements, validarFormElements, handleCreateElements,
                        nextPage, previousPage, goToPage, totalPageCount, currentPage,loading,
                        formValuesElements, handleInputChangeElements, handleUpdateValuesElements, handleSelectValuesElements,
                        catwsprocess,validacionesElements
                      }}
                /> :(method === "updateddilution")
                ?
                <FormDilutionCreate
                    button={ModalButtonUpdate}
                    {...{
                        methodAction: saveUpdateDilutions,handleSearchWSSDilutions,handleUpdateDilutions,handleDeleteDilutions,
                        saveDeleteDilutions,validarFormDilutions,handleCreateDilutions,saveCreateDilutions,
                        formValuesDilutions, handleInputChangeDilutions, handleUpdateValuesDilutions, handleSelectValuesDilutions,
                        validacionesDilutions,loading,catwsprocess
                      }}
                /> : (method === "deleteelement")
                ?
                <DeleteFormElementWS
                    {...{
                        methodAction: saveUpdateElements,catwselement, id_elements_config, dataDatacatwselementSearch,
                        handleSearchWSSElements, handleUpdateElements, saveUpdateElements, handleDeleteElements,
                        saveDeleteElements, validarFormElements, handleCreateElements,
                        nextPage, previousPage, goToPage, totalPageCount, currentPage,loading,
                        formValuesElements, handleInputChangeElements, handleUpdateValuesElements, handleSelectValuesElements,
                        catwsprocess,validacionesElements,toggle,modal, modalTitle,
                      }}
                />
                :(method === "deletedilution")
                ?
                <DeleteFormDilutions
                    {...{
                       handleSearchWSSDilutions,handleUpdateDilutions,saveUpdateDilutions,handleDeleteDilutions,
                        saveDeleteDilutions,validarFormDilutions,handleCreateDilutions,saveCreateDilutions,
                        formValuesDilutions, handleInputChangeDilutions, handleUpdateValuesDilutions, handleSelectValuesDilutions,
                        validacionesDilutions,loading,catwsprocess,toggle, modal, modalTitle
                      }}
                />
                :
                <DeleteFormProcessWS
                    {...{catwsprocess, datadeterminations, validaciones,
                        method,handleInputChange, handleSearchWSS, loading, 
                        toggle, modal, modalTitle,saveCreate, saveUpdate, saveDelete,
                        nextPage, previousPage, goToPage, totalPageCount, currentPage,
                        handleUpdateValues,handleSelectValues,formValues,handleSelectValuesNew,
                        id_exam,idwsconfig, order_element, name,comment_dilutions_colonies,is_lm, is_ec}}
                />
            }
        </Modal>
    )
}